module.exports = __webpack_public_path__ + "img/01.44b690b3.jpg";